import { ApplicationInsights, type IExceptionTelemetry } from '@microsoft/applicationinsights-web'

let appInsights: ApplicationInsights

export function enableAppInsights() {
  const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTIONSTRING
  if (connectionString) {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTIONSTRING
      }
    })
    appInsights.loadAppInsights()
    appInsights.trackPageView()
  }
}

export function trackException(ex: IExceptionTelemetry) {
  if (appInsights) {
    appInsights.trackException(ex)
  }
}
